export const hasOnlyHtmlTags = (input = "") => {
  const textOnly = input.replace(/<[^>]*>/g, "");
  return textOnly.trim().length === 0;
};

export const buildTaskNotePreview = (task) => ({
  title: task?.title ? `${task.title}` : "",
  content: "",
  date: new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }),
  taskId: task?.id,
});

export const buildCreateNotePayload = (note) => ({
  content: note.content || "",
  title: note.title || "",
  todo_id: note.taskId,
  ...(note?.color_code ? { color_code: note.color_code } : {}),
});

export const buildUpdateNotePayload = (note) => ({
  content: note.content,
  title: note.title || "",
  ...(note?.color_code ? { color_code: note.color_code } : {}),
});
